var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCiezarowyZZabudowa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 221.42 124.5",
    width: 110,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .d {\r\n        fill: none;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 7px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    "data-name": "Layer 1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    stroke: "#000",
    points: "71.78 107.38 153.53 107.38 132.78 75.62"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    stroke: "#000",
    cx: 17.28,
    cy: 107.22,
    r: 13.78
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    stroke: "#000",
    cx: 56.28,
    cy: 107.22,
    r: 13.78
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    stroke: "#000",
    cx: 183.2,
    cy: 107.22,
    r: 13.78
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    stroke: "#000",
    points: "153.53 107.38 153.53 29.71 191.58 29.71 217.92 68.87 217.92 107.38 212.33 107.38"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    stroke: "#000",
    points: "173.65 44.32 173.65 68.88 202.2 68.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    stroke: "#000",
    d: "M132.42,76.08c-1.66,7.76-8.87,13.05-16.77,12.3l-38.03-3.6c-9.3-.88-18.39-3.28-26.91-7.09L13.73,61.14c-6.74-3.02-10.45-10.33-8.91-17.54l2.96-13.86,2.96-13.86c1.54-7.22,7.92-12.37,15.3-12.37h40.51c9.34,0,18.61,1.53,27.46,4.52l36.18,12.25c7.52,2.55,11.94,10.32,10.28,18.08l-4.03,18.86-4.03,18.86Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    stroke: "#000",
    x1: 30.78,
    y1: 68.62,
    x2: 14.78,
    y2: 93.62
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCiezarowyZZabudowa);
export default __webpack_public_path__ + "static/media/ciezarowy_z_zabudowa.d0803dd8916cba21e6a52761025d1093.svg";
export { ForwardRef as ReactComponent };